module.exports = __webpack_public_path__ + "media/images/fm_11-21f91ba2d4f748d70108c3a37c0fb3a0.png";